/** Fenz.AI shield mark + wordmark. */
export function ShieldMark({ size = 30 }: { size?: number }) {
  const id = "fenz-shield";
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden>
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop stopColor="#22d3ee" />
          <stop offset="1" stopColor="#3b82f6" />
        </linearGradient>
      </defs>
      <path
        d="M32 6l20 6.7v15.5c0 13.9-8.6 23.2-20 26.8-11.4-3.6-20-12.9-20-26.8V12.7L32 6z"
        fill={`url(#${id})`}
        fillOpacity="0.14"
      />
      <path
        d="M32 6l20 6.7v15.5c0 13.9-8.6 23.2-20 26.8-11.4-3.6-20-12.9-20-26.8V12.7L32 6z"
        stroke={`url(#${id})`}
        strokeWidth="2.75"
        strokeLinejoin="round"
      />
      <path d="M35 18L23 36h8l-3 12 13-19h-8l2-11z" fill={`url(#${id})`} />
    </svg>
  );
}

export function Logo({ size = 30 }: { size?: number }) {
  return (
    <div className="flex items-center gap-2.5 select-none">
      <ShieldMark size={size} />
      <div className="leading-none">
        <span className="text-[15px] font-extrabold tracking-tight text-ink">
          Fenz<span className="text-brand">.AI</span>
        </span>
      </div>
    </div>
  );
}
